import React, { useEffect } from "react";
import FaqContent from "./FaqContent";
import BGImg from "../assets/img/background.jpg";
import headerImg from "../assets/img/openmouth.png";
import headerImg2 from "../assets/img/openmouth@2x.png";
import logoRed from "../assets/img/logo-red.png";
import logoRed2 from "../assets/img/logo-red@2x.png";
import { useLocation } from "react-router-dom";

function Faq() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div
      className="App"
      style={{
        backgroundImage: `url(${BGImg})`,
        backgroundPosition: "top center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <header className="App-header">
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />
        <div
          className="App-header__img"
          style={{ "--background": `url(${headerImg})` }}
        />

        <img
          className="App-header__img-placeholder"
          src={headerImg}
          srcSet={`${headerImg} 1x, ${headerImg2} 2x`}
          alt="Open Mouth, what's in the box?"
        />
      </header>
      <main>
        <img
          className="odd-logo"
          src={logoRed}
          srcSet={`${logoRed} 1x, ${logoRed2} 2x`}
          alt="One Day Die Logo"
        />
        <FaqContent />
      </main>
    </div>
  );
}

export default Faq;
